import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { StandardDialog } from '@roc/ui';
import { PricingEconomicsStepper } from './pricingEconomicsStepper';
import { CompanyProfileStore } from '../../stores/companyProfileStore';
import TermTierSelection from './termTierSelection';
import { SearchBorrowersForPricingEconomicsTier } from './searchBorrowersForPricingEconomicsTier';
import PricingEconomicsDefaultFees from './pricingEconomicsDefaultFees';

export type AddPricingEconomicsTierDialogProps = {
  open: boolean;
  handleClose: () => void;
  title: string;
  companyProfileStore: CompanyProfileStore
};

export const AddPricingEconomicsTierDialog = observer((props: AddPricingEconomicsTierDialogProps) => {
  const { open, handleClose, title, companyProfileStore } = props;
  const { lenderTermTierEconomicsFormStore } = companyProfileStore

  const stepsLabels = ['Term Tier Selection', 'Select Borrower(s) for Economics', 'Defaults Fees']
  const stepsContent = [<TermTierSelection companyProfileStore={companyProfileStore} />, <SearchBorrowersForPricingEconomicsTier companyProfileStore={companyProfileStore} />, <PricingEconomicsDefaultFees companyProfileStore={companyProfileStore} />]

  const onSave = () => {
    lenderTermTierEconomicsFormStore.saveTermTier()
    if (lenderTermTierEconomicsFormStore.form.meta.isValid) {
      handleClose()
    }
  }

  return (
    <StandardDialog
      maxWidth={'md'}
      open={open}
      title={title}
      handleClose={handleClose}
      dialogContent={
        <>
          <PricingEconomicsStepper onSave={onSave} stepsLabel={stepsLabels} stepsContent={stepsContent} companyProfileStore={companyProfileStore} />
        </>
      }
    />
  );
});

export default AddPricingEconomicsTierDialog;
